import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ControlHorariPrivat from "./ControlHorariPrivat";
import ControlHorariLogin from "./ControlHorariLogin";
import ControlHorariInici from "./ControlHorariInici";
import ControlHorariFitxar from "./ControlHorariFitxar";
import ControlHorariHistoric from "./ControlHorariHistoric";
import ControlHorariRegistres from "./ControlHorariRegistres";
import ControlHorariAjuda from "./ControlHorariAjuda";
import { chRegistrarServiceWorker } from "./chServiceWorker";
import { chAplicarCapcaleraPwa } from "./chPwaHead";
import "./controlhorari.css";

// Portal mòbil aïllat de l'ERP general (CURRENT_TASK.md §5.2): muntat a
// App.js com a "/Control_Horari/*", amb les seves pròpies rutes internes.
// No renderitza mai res de l'ERP (Header, Dashboard, etc.).
function ControlHorariApp() {
  useEffect(() => {
    chRegistrarServiceWorker();
    return chAplicarCapcaleraPwa();
  }, []);

  return (
    <Routes>
      <Route path="login" element={<ControlHorariLogin />} />
      <Route
        path="avui"
        element={
          <ControlHorariPrivat>
            <ControlHorariInici />
          </ControlHorariPrivat>
        }
      />
      <Route
        path="fitxar"
        element={
          <ControlHorariPrivat>
            <ControlHorariFitxar />
          </ControlHorariPrivat>
        }
      />
      <Route
        path="historic"
        element={
          <ControlHorariPrivat>
            <ControlHorariHistoric />
          </ControlHorariPrivat>
        }
      />
      <Route
        path="registres"
        element={
          <ControlHorariPrivat>
            <ControlHorariRegistres />
          </ControlHorariPrivat>
        }
      />
      <Route
        path="ajuda/:tema"
        element={
          <ControlHorariPrivat>
            <ControlHorariAjuda />
          </ControlHorariPrivat>
        }
      />
      <Route path="*" element={<Navigate to="avui" replace />} />
    </Routes>
  );
}

export default ControlHorariApp;
